<div class="uk-section-default uk-section uk-section-small uk-padding-remove-top uk-padding-remove-bottom" style="min-height: 325px">
    <div class="uk-container uk-container-large">
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid="">
            <div class="uk-width-1-1@m uk-first-column">
                <h2>EOSC Service Catalogue REST API</h2>
                <div class="uk-container uk-container-large uk-margin-medium-top uk-margin-medium-bottom">
                    <div class="uk-grid">
                        <div class=" uk-width-expand@m">
                           ﻿<div>
                                <div id="api-endpoints" class="section">

                                  <p>The EOSC Service Catalogue provides a REST API interface for access to the
                                    Catalogues Providers, Resources, Controlled Vocabularies and other related
                                    entities. An API (Application programming interface) is a protocol intended to be
                                    used as an interface by software components to communicate with each other. The
                                    complete <a href="../api/swagger-ui/index.html" target="_blank">EOSC API documentation</a> is a living document, generated using frameworks
                                    compliant with OpenAPI Specification 2.0.</p>

                                  <p>If you find a bug, have any questions or suggestions, please <a [href]="'mailto:' + catalogueSupportEmail">get in touch with us</a>.</p>

                                  <p>In general, publicly available information providers and resources stored in the
                                    Service Catalogue does not require an authentication. However, if alterations to the
                                    data stored are needed, then authentication is mandatory. For this, an API Token is
                                    needed.</p>

                                  <p>You can obtain an API token <a href="{{apiTokenEndpoint}}" target="_blank">here</a>, just authorise the webpage to read your account
                                    details in order to be able to issue new access and refresh tokens. Access tokens
                                    expire in one hour so you’ll also need the refresh token to re-generate access
                                    tokens programmatically when they expire. Refresh tokens expire at the end of each
                                    year, so you’ll also need to reissue new refresh tokens from year to year. In case
                                    you need to reissue or manage refresh tokens, you can easily do it, just follow the
                                    instructions <a href="https://core-proxy.sandbox.eosc-beyond.eu/auth/realms/core/account/#/applications" target="_blank">here</a>.</p>

                                  <p>The obtained token can be used in a bearer authorization header like this: 'Authorization: Bearer [token]'.
                                    <br>For example, a call for adding a new resource goes like this:</p>
                                  <pre class="uk-padding-remove">
                                    <code>
   curl -X POST
   --header 'Content-Type: application/json'
   --header Authorization: Bearer &lt;TOKEN&gt;'
   --header 'Accept: application/json'
   -d '&lt;input data in json format&gt;' 'https://api.providers.sandbox.eosc-beyond.eu/&lt;resource&gt;'</code>
                                  </pre>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
